import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container, Nav, NavItem, TabContent, TabPane, NavLink } from 'reactstrap';
import _ from 'lodash';
import ApiKeys from '../user/ApiKeys';
import ClientEditPage from './EditClient';
import classnames from 'classnames';


interface IClientPageProps extends RouteComponentProps<{ clientId?: string }> {
    isEditing: boolean;
};

interface IClientPageState {
    tab: string;
}

type TabName = 'editClient' | 'apikeys' | '';

export default class ClientPage extends React.Component<IClientPageProps, IClientPageState>{

    constructor(props: IClientPageProps) {
        super(props)
        this.state = {
            tab: 'editClient',
        }
    }

    selected = (tab: TabName) => this.state.tab === tab;

    toggle = (tab: TabName) => {
        if (this.state.tab !== tab) {
            this.setState({ tab })
        }
    }

    public render() {
        return (
            <Container>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('editClient') })}
                            onClick={() => this.toggle('editClient')} to={''}>Edit Client</NavLink>
                    </NavItem>
                    {this.props.isEditing && <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('apikeys') })}
                            onClick={() => this.toggle('apikeys')} to={''}>Api Keys</NavLink>
                    </NavItem>}
                </Nav>
                <TabContent activeTab={this.state.tab} className={this.state.tab}>
                    <TabPane tabId='editClient'>
                        <ClientEditPage  {...this.props} isEditing={this.props.isEditing} />
                    </TabPane>
                    {this.props.isEditing && <TabPane tabId='apikeys'>
                        <ApiKeys id={this.props.match.params.clientId!} />
                    </TabPane>}
                </TabContent>
            </Container>
        )
    }
}